// ─────────────────────────────────────────────
//  RateSlider.jsx
//  Slider de tasa de rendimiento anual
// ─────────────────────────────────────────────

import React from 'react';
import styles from './RateSlider.module.css';

const RATE_MIN = 1;
const RATE_MAX = 40;
const QUICK_RATES = [5, 10, 12, 15, 20];

export default function RateSlider({ value, onChange }) {
	const fillPct = ((value - RATE_MIN) / (RATE_MAX - RATE_MIN)) * 100;

	return (
		<section className={styles.card} aria-label="Tasa de rendimiento anual">

			<div className={styles.header}>
				<div>
					<p className={styles.label}>Tasa Anual</p>
					<p className={styles.pctDisplay} aria-live="polite">
						{value}<span className={styles.pctSign}>%</span>
					</p>
				</div>
				<p className={styles.hint} aria-hidden="true">rendimiento estimado</p>
			</div>

			<div className={styles.trackWrap}>
				<div className={styles.trackBg}>
					<div className={styles.trackFill} style={{ width: `${fillPct}%` }} />
				</div>
				<input
					type="range"
					className={styles.slider}
					min={RATE_MIN}
					max={RATE_MAX}
					step={0.25}
					value={value}
					aria-label="Tasa de rendimiento anual"
					aria-valuemin={RATE_MIN}
					aria-valuemax={RATE_MAX}
					aria-valuenow={value}
					aria-valuetext={`${value} por ciento anual`}
					onChange={(e) => onChange(Number(e.target.value))}
				/>
			</div>

			<div
				className={styles.quickBtns}
				role="group"
				aria-label="Tasas de acceso rápido"
			>
				{QUICK_RATES.map((rate) => (
					<button
						key={rate}
						className={`${styles.quickBtn} ${value === rate ? styles.quickBtnActive : ''}`}
						onClick={() => onChange(rate)}
						type="button"
						aria-pressed={value === rate}
						aria-label={`${rate} por ciento anual`}
					>
						{rate}%
					</button>
				))}
			</div>

		</section>
	);
}
